import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "menu", "chevron"]

  toggle(event) {
    const clickedButton = event.currentTarget
    const menu = clickedButton.nextElementSibling
    const chevron = clickedButton.querySelector('.chevron')

    this.buttonTargets.forEach((button, index) => {
      const currentMenu = this.menuTargets[index]
      const currentChevron = this.chevronTargets[index]

      if (button === clickedButton) {
        currentMenu.classList.toggle('hidden')
        currentChevron.classList.toggle('rotate-180')
      } else {
        currentMenu.classList.add('hidden')
        currentChevron.classList.remove('rotate-180')
      }
    })
  }
}
